// App.js
import { BrowserRouter, useNavigate } from "react-router-dom";
import AppRouter from "./router/AppRouter";
import { observer } from "mobx-react-lite";
import { useContext, useEffect, useState } from "react";
import { $host } from "./http";
import { Context } from "./index";
import { useLocalStorage } from "usehooks-ts";
import { useCookies } from "react-cookie";
import { ModalProvider } from "./context/ModalContext"; // ✅ Импортируем контекст
import LoadingSpinner from "./components/LoadingSpinner/LoadingSpinner"; // Кастомный спиннер
import './index.css';

const App = observer(() => {
    const { user } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [userCached, setUserCached, removeUserCached] = useLocalStorage('user', null);
    const [token, setToken, removeToken] = useCookies(['access_token']);

    const checkCachedToken = async (token) => {
        setLoading(true); // ✅ Загружаем только при проверке
        try {
            const { data } = await $host.get('/api/protected/ping', {
                headers: { 'Cookie': `access_token=${token}` }
            });
            user.setUser(data.body);
            setUserCached(data);
            navigate(user.userHomePath);
        } catch (err) {
            removeToken();
            removeUserCached();
            user.setUser(null);
            navigate('/');
        }
        setLoading(false); // ✅ Убираем загрузку только после завершения запроса
    };


    useEffect(() => {
        if (!user.isAuth && (token || userCached)) {
            checkCachedToken(token || userCached.token);
        }
    }, []);


    if (loading) {
        return <LoadingSpinner />; {/* Заменяем стандартную загрузку на кастомную */ }
    }

    window.onerror = function (message, source, lineno, colno, error) {
        console.error("Глобальная ошибка:", { message, source, lineno, colno, error });
    };

    return (
        <ModalProvider>  {/* ✅ Оборачиваем в `ModalProvider`, чтобы он был доступен везде */}
            <AppRouter />
        </ModalProvider>
    );
});

const Root = () => (
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

export default Root;
